import React from "react";
import { Upload, Icon } from "@tinper/next-ui";
const prefix = "as-dataForm";

export default class ImageUpload extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      fileList: []
    };
  }

  render () {
    // const { fileList } = this.state;
    const {
      action,
      onChange,
      listType = "picture-card",
      showUploadList = {},
      ...restProps
    } = this.props;
    return (
      <Upload
        action={action}
        listType={listType}
        showUploadList={{ showRemoveIcon: true, ...showUploadList }}
        onChange={(fileList) => {
          this.setState({ fileList });
          onChange && onChange(fileList);
        }}
        {...restProps}
        accept="image/*"
      >
        <Icon type="uf-plus" className={`${prefix}-imageupload-icon`} />
        <p className={`${prefix}-imageupload-title`}>点击上传</p>
      </Upload>
    );
  }
}
